import React, { Component } from 'react'
import T from 'prop-types'
import Psfs from 'lib/psfs/Psfs'
import FuncHelper from 'helpers/functions'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import * as ROUTE from 'constants/appRouting'
import MaterialTable from 'components/common/Table/DataTable/MaterialTable'
import ColumnCollection from 'types/table/ColumnCollection'
import ActionCollection from 'types/table/ActionCollection'
import CircleLoader from 'components/Loading/CircleLoader'
import LicenseeSelect from 'components/common/LicenseeSelect'
import ConfirmDialog from './Popup/ConfirmDialog'
import ModalWindow from './Modals/ModalWindow'

const MOBILE_BACK_BUTTON_ROUTES = [
  ROUTE.JOBS_WORKFLOW_ADMIN,
  ROUTE.LICENSEE_LIST,
  ROUTE.APPLICATION_LIST,
  ROUTE.LICENSEE_APPLICATION_LIST,
  ROUTE.SISENSE_LIST,
  ROUTE.SITE_LIST,
  ROUTE.SITE_GROUP_LIST,
  ROUTE.LOCUS_LIST,
  ROUTE.LOCUS_GROUP_LIST,
  ROUTE.USER_LIST,
  ROUTE.USER_GROUP_LIST,
]

class ListFromTable extends Component {
  getTableData = FuncHelper.emptyFunc

  getTableFilters = FuncHelper.emptyFunc

  deleteEntity = FuncHelper.emptyFunc

  clearReducerState = FuncHelper.emptyFunc

  onSortChangeEvent = FuncHelper.emptyFunc

  onPageChangeEvent = FuncHelper.emptyFunc

  onSizePerPageListEvent = FuncHelper.emptyFunc

  asyncData = false

  loadingData = false

  constructor(props) {
    super(props)

    this.state = {
      pathname: '',
      openDialog: false,
      openCopyDialog: false,
      licensee: null,
      copyDialogAction: null,
      copyDialogParams: null,
      confirmParams: {},
      deleteAction: null,
    }

    this.init()
  }

  componentDidMount() {
    this.getTableFilters()
    this.getTableData({ psfs: this.psfs })
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { isStateCriteria } = this.props

    if (
      !isStateCriteria &&
      nextProps.location.pathname !== this.props.location.pathname
    ) {
      this.reloadTableData(nextProps.location.pathname)

      return false
    }

    if (isStateCriteria && nextState.pathname !== this.state.pathname) {
      this.reloadTableData(nextState.pathname)

      return false
    }

    return true
  }

  componentWillUnmount() {
    this.clearReducerState()
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  onOpenCopyDialog = () => {
    this.setState({ openCopyDialog: true })
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  onOpenConfirmDialog = (confirmParams, deleteAction) => {
    this.setState({ openDialog: true, confirmParams, deleteAction })
  }

  onCloseConfirmDialog = () => {
    this.setState({ openDialog: false })
  }

  onCloseCopyDialog = () => {
    this.setState({ openCopyDialog: false })
  }

  onConfirmActionConfirmDialog = () => {
    const { confirmParams, deleteAction } = this.state

    if (confirmParams) {
      if (deleteAction) {
        deleteAction(confirmParams)
      } else {
        this.deleteEntity(confirmParams)
      }
    }

    this.onCloseConfirmDialog()
  }

  getConfirmDialogProps() {
    return {
      title: 'Title',
      message: 'message',
    }
  }

  getTableProps() {
    return {
      title: 'List',
      sorting: false,
      paging: false,
      filtering: false,
      searching: false,
      creating: false,
      goBack: false,
      dense: {
        enabled: false,
        state: false,
        handler: () => {},
      },
    }
  }

  getCreateButton() {
    return {
      title: 'Create entity',
      link: '#',
    }
  }

  getColumns() {
    return new ColumnCollection()
  }

  getActions() {
    return new ActionCollection()
  }

  getFilters() {
    return {}
  }

  init = () => {
    const { isStateCriteria, history, location } = this.props

    if (isStateCriteria) {
      this.psfs = Psfs.create('')
      this.historyPush = path => {
        this.setState({ pathname: path })
      }
    } else {
      this.psfs = Psfs.create(location.pathname)
      this.historyPush = history.push
    }
  }

  appendUrlParams = params => {
    const {
      location: { search },
    } = this.props

    if (search && search.length) {
      const queryParams = new URLSearchParams(search)

      queryParams.forEach((paramToAppend, paramName) => {
        if (paramToAppend && paramName !== 'backUrlParams') {
          params.append(paramName, paramToAppend)
        }
      })
    }
  }

  onSortChange = (field, order) => {
    const params = new URLSearchParams()

    this.appendUrlParams(params)
    this.psfs.addSort(field, order)
    this.onSortChangeEvent(this.psfs.sortObj.field, this.psfs.sortObj.order)
    this.historyPush(
      `${this.psfs.path}${params ? `?${params.toString()}` : ''}`,
    )
  }

  onPageChange = (event, page) => {
    const params = new URLSearchParams()

    this.appendUrlParams(params)
    this.psfs.createPagination(page + 1, this.psfs.paginationObj.limit)
    this.onPageChangeEvent(this.psfs.paginationObj.page)
    this.historyPush(
      `${this.psfs.path}${params ? `?${params.toString()}` : ''}`,
    )
  }

  onSizePerPageList = (event, { props: { value } }) => {
    const params = new URLSearchParams()

    this.appendUrlParams(params)
    this.psfs.createPagination(1, value)
    this.onSizePerPageListEvent(this.psfs.paginationObj.limit)
    this.historyPush(
      `${this.psfs.path}${params ? `?${params.toString()}` : ''}`,
    )
  }

  reloadTableData(path) {
    this.psfs.init(path)
    this.getTableData({ psfs: this.psfs })
  }

  render() {
    const {
      responsive,
      alwaysShowTableHead,
      tableData,
      location,
      history,
    } = this.props
    const { licensee, copyDialogAction, copyDialogParams } = this.state
    const dataFromTable = tableData.toJS ? tableData.toJS() : tableData

    if (this.asyncData && this.loadingData) {
      return <CircleLoader loading />
    }

    const { sortObj, paginationObj } = this.psfs
    const tableProps = this.getTableProps()
    const createButton = this.getCreateButton()
    const tableColumns = this.getColumns()
    const rowActions = this.getActions()
    const confirmProps = this.getConfirmDialogProps()
    const filters = this.getFilters()
    const { openDialog, openCopyDialog } = this.state
    const passwordModal = this.getPasswordModal
    const isMobileResolution = ifWindowWidthLessThan(992)
    const currentPath = location && location.pathname ? location.pathname : ''
    const shouldShowMobileBackButton =
      !tableProps.goBack &&
      isMobileResolution &&
      MOBILE_BACK_BUTTON_ROUTES.includes(currentPath)
    const goBack =
      shouldShowMobileBackButton && history && history.push
        ? () => history.push(ROUTE.APPS)
        : tableProps.goBack

    return (
      <div className="table-container container-fluid no-breadcrumb">
        {!!passwordModal && passwordModal()}
        <MaterialTable
          responsive={responsive}
          psfs={this.psfs}
          tableRef={this.tableRef}
          {...tableProps}
          goBack={goBack}
          {...{
            createButton,
            filters,
            columns: tableColumns,
            actions: rowActions,
            data: dataFromTable.data,
            noDataMessage: this.getTableProps().noDataMessage,
            sort: {
              field: sortObj.field,
              order: sortObj.order,
              onSortChange: this.onSortChange,
            },
            paginator: {
              count: dataFromTable.count,
              page: paginationObj.page - 1,
              rowsPerPage: paginationObj.limit,
              rowsPerPageOptions: [10, 20, 50, 100],
              onChangePage: this.onPageChange,
              onChangeRowsPerPage: this.onSizePerPageList,
            },
            alwaysShowTableHead,
          }}
        />
        <ConfirmDialog
          open={openDialog}
          onClose={this.onCloseConfirmDialog}
          onConfirmAction={this.onConfirmActionConfirmDialog}
          title={confirmProps.title}
          message={confirmProps.message}
        />
        <ModalWindow open={openCopyDialog} onClose={this.onCloseCopyDialog}>
          <LicenseeSelect
            selected={licensee}
            setSelected={licensee => this.setState({ licensee })}
            onClose={this.onCloseCopyDialog}
            onSubmit={() =>
              copyDialogAction({ ...copyDialogParams, data: { licensee } })
            }
          />
        </ModalWindow>
      </div>
    )
  }
}

ListFromTable.propTypes = {
  tableData: T.object.isRequired,
}

export default ListFromTable
